/**
 * El `srcset` de una imagen con copias achicadas (el backend las genera al
 * subir: `almacen/variantes.ts`). Con él, el navegador baja la copia que
 * alcanza para el ancho en que se ve y no el original de 1920 px.
 */
import type { VarianteImagen } from '@elcarpintero/compartido';

/** Las copias y el original, de menor a mayor. Sin copias no hay nada que elegir. */
export function srcSetDe(
  url: string,
  ancho: number,
  variantes: readonly VarianteImagen[],
): string | undefined {
  if (variantes.length === 0) return undefined;

  return [...variantes, { url, ancho }]
    .sort((a, b) => a.ancho - b.ancho)
    .map((variante) => `${variante.url} ${String(variante.ancho)}w`)
    .join(', ');
}

/**
 * El atributo `sizes`. Una imagen diferida deja que el navegador lo mida
 * (`auto`, Chrome 126+); los demás saltan esa palabra y usan el respaldo. La que
 * se carga de inmediato no puede usar `auto`: todavía no hay maqueta que medir.
 */
export function sizesDe(tamanos: string, diferida: boolean): string {
  return diferida ? `auto, ${tamanos}` : tamanos;
}

/** La copia más chica, o el original si no tiene: para un fondo difuminado. */
export function urlMasChica(url: string, variantes: readonly VarianteImagen[]): string {
  const [masChica] = [...variantes].sort((a, b) => a.ancho - b.ancho);
  return masChica?.url ?? url;
}
